<template>
<div class="avoid-page-break-before">
  <div v-if="!isPrintVersion" class="avoid-page-break-before">
    <!-- Admin/advisor features -->
    <el-collapse accordion v-if="comments.length > 0 || userIsAdmin">
      <el-collapse-item class="add-comment" name="1">
        <template slot="title">
          <i v-if="userIsAdmin" class="el-icon-edit"></i><span class="comment-title">{{ userIsAdmin ? title.admin : title.advisor }}</span>
        </template>
        <div>
          <div class="comments-list-container">
              <span v-if="comments.length > 0 || newComments.length > 0" class="comments-label">Comentarios:</span>
              <ul>
                <li v-for="item in comments" :key="item.id">{{ item.comment }}</li>
                <li v-for="item in newComments" :key="item.id">{{ item.comment }}</li>
              </ul>
          </div>
          <!-- Admin comment input  -->
          <div v-if="userIsAdmin" class="comment-input-container">
            <span class="comments-label">Agregar:</span>
            <el-input class="comment-input" type="textarea" placeholder="Comentario de mercado..." v-model="inputContent"></el-input>
            <el-button class="comment-input-button" size="small"  v-on:click="addComment()" :disabled="inputContent.length === 0 ">Agregar</el-button>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
  <div v-if="isPrintVersion && comments.length > 0" class="printVersionComments avoid-page-break-before">
    <p v-for="item in comments" :key="item.id">{{ item.comment }}</p>
  </div>
</div>
</template>

<script>
import { addComment } from '@/graphql'
export default {
  name: 'CommentsSection',
  props: {
    content: String,
    isPortfolioOverview: Boolean,
    isAssetClassView: Boolean,
    isInvestmentView: Boolean,
    comments: Array,
    assetClassId: Number,
    investmentId: Number,
    isPrintVersion: Boolean
  },
  data () {
    return {
      title: {
        admin: 'Ver y agregar comentarios',
        advisor: 'Ver comentarios'
      },
      inputContent: '',
      commentData: {},
      newComments: []
    }
  },
  computed: {
    userIsAdmin: function () {
      return this.$store.getters.userIsAdmin
    },
    portofolioId: function () {
      return parseInt(this.$route.params.id)
    }
  },
  methods: {
    addComment() {
    this.commentData = this.getRequestVariables(this.portofolioId,
      this.inputContent)
    this.$apollo.mutate({ mutation: addComment,
      variables: this.commentData
      }).then(data => this.requestSuccess(data.data.addPortfolioComments))
      .catch(() => {
        this.$message({
          type: "error",
          message: "Ocurrió un error intenta más tarde"
        });
      });
    },
    requestSuccess (data) {
      if (this.isPortfolioOverview) {
        this.newComments.push(this.commentData.portfolioComments[0])
      }
      if (this.isAssetClassView) {
        this.newComments.push(this.commentData.assetClassComments[0])
      }
      if (this.isInvestmentView) {
        this.newComments.push(this.commentData.investmentComments[0])
      }
      this.inputContent = ''
      if (data.returnCode === 0) {
        this.$message({ type: "success",
          message: "Comentario agregado"});

      }
    },
    getRequestVariables (id, comment, assetClass) {
      let requestVariables = {}
      if (this.isAssetClassView) {
        requestVariables = {
          portfolioId: id,
          assetClassComments: [{
            idAssetClass: this.assetClassId,
            comment: comment
          }]
        }
      } else if (this.isInvestmentView){
        requestVariables = {
          portfolioId: id,
          investmentComments: [{
            idInvestment:  this.investmentId,
            comment: comment
          }]
        }
      } else if (this.isPortfolioOverview) {
        requestVariables = {
          portfolioId: id,
          portfolioComments: [{
            comment: comment
          }]
        }
      }
      return requestVariables
    }
  }
}
</script>

<style scoped>

  .el-main {
    padding: 0;
    /* text-align: left; */
  }
  .el-icon-edit {
    margin-right: 20px;
  }

  .el-collapse-item {
    display: flex;
    flex-direction: column;
    align-items: left;
  }

  .el-collapse-item.add-comment {
    align-items: left;
  }

  .el-collapse-item__content {
    color: #4A4A4A;
    font-size: 14px!important;
  }

  .comment-title {
    color: #4A4A4A;
    font-size: 14px;
    font-weight: bold;
    margin-right: 10px;
  }

  .comment-input-container {
    width: 100%;
  }

  .comment-input-button {
    width: 80px;
    align-self: flex-end;
  }

  .comments-list-container {
    margin-bottom: 20px;
  }

  .comments-list-container li {
    margin: 0;
    line-height: 25px;
  }

  .comments-label {
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 14px;
  }

  .comment-input {
    margin-bottom: 15px;
  }

  .printVersionComments p {
    font-size: 12px;
    color: #606266;
  }

  .printVersion .printVersionComments {
    margin-top: 0px;
  }

  .printVersionComments {
    page-break-inside: avoid;
  }

    /* For the subtitles */

  .printVersion .section-title {
    position: relative;
    bottom: 28px;
    margin-top: 26px;
    font-size: 14px;
    font-weight: 600;
    color: #3e67de;
  }
</style>



// WEBPACK FOOTER //
// src/components/CommentsSection.vue